import jobRatingDetailsImg from './job-rating-details.png'
import jobsPendingFeedback from './jobs-pending-feedback.png'

export const images = {
  jobRatingDetailsImg,
  jobsPendingFeedback,
}
